// Utilidades de duração — internamente tudo é duration_min (float, aceita fração p/ segundos)

export interface HMS {
  h: number;
  m: number;
  s: number;
}

export function minToHMS(totalMin: number): HMS {
  const totalSec = Math.round((totalMin || 0) * 60);
  return {
    h: Math.floor(totalSec / 3600),
    m: Math.floor((totalSec % 3600) / 60),
    s: totalSec % 60,
  };
}

export function hmsToMin(h: number, m: number, s: number): number {
  const totalSec = (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
  return totalSec / 60;
}

/** "1h 30min 45s" · "12min 30s" · "45s" · "0min" */
export function formatDuration(totalMin: number): string {
  const { h, m, s } = minToHMS(totalMin);
  const parts: string[] = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}min`);
  if (s > 0) parts.push(`${s}s`);
  return parts.length > 0 ? parts.join(' ') : '0min';
}

/** Versão compacta "1:30:45" para tabelas */
export function formatDurationClock(totalMin: number): string {
  const { h, m, s } = minToHMS(totalMin);
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Converte string/number de planilha em minutos.
 * - "01:30:45" (h:m:s) → 90.75
 * - "12:30" (m:s — convenção de duração de vídeo) → 12.5
 * - "90" ou 90 → 90
 * - 0.0625 (fração de dia do Excel = 1h30) → 90
 */
export function parseDurationValue(v: unknown, defaultMin = 30): number {
  if (typeof v === 'number') {
    if (v > 0 && v < 1) return v * 24 * 60; // Excel time serial (fração de dia)
    return v > 0 ? v : defaultMin;
  }
  if (typeof v !== 'string') return defaultMin;
  const str = v.trim();
  if (!str) return defaultMin;

  const parts = str.split(':').map((p) => Number.parseInt(p, 10));
  if (parts.length === 3 && parts.every((n) => !Number.isNaN(n))) {
    return hmsToMin(parts[0], parts[1], parts[2]);
  }
  if (parts.length === 2 && parts.every((n) => !Number.isNaN(n))) {
    // convenção vídeo: m:s
    return hmsToMin(0, parts[0], parts[1]);
  }
  const n = Number.parseFloat(str.replace(',', '.'));
  return Number.isNaN(n) || n <= 0 ? defaultMin : n;
}
